import { BaseApiService } from '@/services/base-service';
import { BaseResponse } from '@/types';
import { Brands } from '../types';

interface BrandPublic extends BaseResponse {
  data: {
    banner: string;
    design: Brands.Design[];
    brand: Brands.Brand;
    partnership: Brands.PartnerShip[];
  }
}

interface DesignDetail extends BaseResponse {
  data: {
    title: string;
    design_page_list: Brands.DesingPageList[];
    blocks: Brands.DesingBlock[];
  }
}

export class BrandPortalService extends BaseApiService {
  private readonly base_path = 'brand-portal';

  async get_public_info(): Promise<BrandPublic> {
    const { data } = await this.http_client.get<BrandPublic>(this.base_path);

    return data;
  }

  async get_disign_by_id(id: string | number): Promise<DesignDetail> {
    const url = `${this.base_path}/design/${id}`;
    const { data } = await this.http_client.get<DesignDetail>(url);

    return data;
  }
}
